import type { FC } from "react";
import type { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

interface IClicksBySourceType {
    Organic: number;
    Paid: number;
}

interface IBreakdownData {
    Clicks: IClicksBySourceType;
    Volume: number;
}

export interface IBreakdown {
    [date: string]: IBreakdownData;
}

export interface IAverage {
    Clicks: IClicksBySourceType;
    Volume: number;
}

export interface ITrendOverTimeResponseData {
    Breakdown: IBreakdown;
    Average: IAverage;
}

export enum MetricNames {
    VOLUME = "Volume",
    CLICKS = "Clicks",
    ORGANIC = "Organic",
    PAID = "Paid",
}

export interface IBaseMetricItem {
    name: string;
    id: MetricNames;
    color: string;
    visible: boolean;
    customLegendComponent?: FC;
    legendComponentWrapper?: FC;
    type: string;
    zIndex?: number;
}

export interface IGraphItem extends IBaseMetricItem {
    data: Highcharts.Series["data"];
    total: number;
}

export enum GraphSourceTypeView {
    BREAKDOWN = "breakdown",
    TOTAL = "total",
}

export interface ISwitcherItem {
    title: string;
    value: GranularityNames | string;
    disabled: boolean;
    isLocked?: boolean;
}

interface AggregatedSourceTypeData {
    Clicks: [number, number][];
    Volume: [number, number][];
}

interface SourceTypeBreakdownData {
    Organic: [number, number][];
    Paid: [number, number][];
    Volume: [number, number][];
}

export type DataSplitByMetric = AggregatedSourceTypeData | SourceTypeBreakdownData;

interface AggregatedSourceTypeAverageData {
    Clicks: number;
    Volume: number;
}

interface SourceTypeBreakdownAverageData extends IClicksBySourceType {
    Volume: number;
}

export type AverageSplitByMetric = AggregatedSourceTypeAverageData | SourceTypeBreakdownAverageData;
